/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { customersControllerCreate } from '../fn/customers/customers-controller-create';
import { CustomersControllerCreate$Params } from '../fn/customers/customers-controller-create';
import { customersControllerDeletePaymentMethod } from '../fn/customers/customers-controller-delete-payment-method';
import { CustomersControllerDeletePaymentMethod$Params } from '../fn/customers/customers-controller-delete-payment-method';
import { customersControllerGetPaymentMethod } from '../fn/customers/customers-controller-get-payment-method';
import { CustomersControllerGetPaymentMethod$Params } from '../fn/customers/customers-controller-get-payment-method';
import { customersControllerUpdatePaymentMethod } from '../fn/customers/customers-controller-update-payment-method';
import { CustomersControllerUpdatePaymentMethod$Params } from '../fn/customers/customers-controller-update-payment-method';
import { PaymentMethodDto } from '../models/payment-method-dto';

@Injectable({ providedIn: 'root' })
export class CustomersService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `customersControllerCreate()` */
  static readonly CustomersControllerCreatePath = '/keus-payments/customers';

  /**
   * Create a new user data entry.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `customersControllerCreate()` instead.
   *
   * This method doesn't expect any request body.
   */
  customersControllerCreate$Response(params?: CustomersControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return customersControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Create a new user data entry.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `customersControllerCreate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  customersControllerCreate(params?: CustomersControllerCreate$Params, context?: HttpContext): Observable<string> {
    return this.customersControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `customersControllerGetPaymentMethod()` */
  static readonly CustomersControllerGetPaymentMethodPath = '/keus-payments/customers/{customerId}/payment-method';

  /**
   * Get the payment method of a customer.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `customersControllerGetPaymentMethod()` instead.
   *
   * This method doesn't expect any request body.
   */
  customersControllerGetPaymentMethod$Response(params: CustomersControllerGetPaymentMethod$Params, context?: HttpContext): Observable<StrictHttpResponse<PaymentMethodDto>> {
    return customersControllerGetPaymentMethod(this.http, this.rootUrl, params, context);
  }

  /**
   * Get the payment method of a customer.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `customersControllerGetPaymentMethod$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  customersControllerGetPaymentMethod(params: CustomersControllerGetPaymentMethod$Params, context?: HttpContext): Observable<PaymentMethodDto> {
    return this.customersControllerGetPaymentMethod$Response(params, context).pipe(
      map((r: StrictHttpResponse<PaymentMethodDto>): PaymentMethodDto => r.body)
    );
  }

  /** Path part for operation `customersControllerUpdatePaymentMethod()` */
  static readonly CustomersControllerUpdatePaymentMethodPath = '/keus-payments/customers/{customerId}/payment-method';

  /**
   * Update the payment method of a customer.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `customersControllerUpdatePaymentMethod()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  customersControllerUpdatePaymentMethod$Response(params: CustomersControllerUpdatePaymentMethod$Params, context?: HttpContext): Observable<StrictHttpResponse<PaymentMethodDto>> {
    return customersControllerUpdatePaymentMethod(this.http, this.rootUrl, params, context);
  }

  /**
   * Update the payment method of a customer.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `customersControllerUpdatePaymentMethod$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  customersControllerUpdatePaymentMethod(params: CustomersControllerUpdatePaymentMethod$Params, context?: HttpContext): Observable<PaymentMethodDto> {
    return this.customersControllerUpdatePaymentMethod$Response(params, context).pipe(
      map((r: StrictHttpResponse<PaymentMethodDto>): PaymentMethodDto => r.body)
    );
  }

  /** Path part for operation `customersControllerDeletePaymentMethod()` */
  static readonly CustomersControllerDeletePaymentMethodPath = '/keus-payments/customers/{customerId}/payment-method';

  /**
   * Delete the payment method of a customer.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `customersControllerDeletePaymentMethod()` instead.
   *
   * This method doesn't expect any request body.
   */
  customersControllerDeletePaymentMethod$Response(params: CustomersControllerDeletePaymentMethod$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return customersControllerDeletePaymentMethod(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete the payment method of a customer.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `customersControllerDeletePaymentMethod$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  customersControllerDeletePaymentMethod(params: CustomersControllerDeletePaymentMethod$Params, context?: HttpContext): Observable<void> {
    return this.customersControllerDeletePaymentMethod$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
